module.exports = __webpack_public_path__ + "media/img/frontend_application/bottomnav/notification-f34e39a4aa34159dea7408ad9f069b45.svg";